export const mediumScreen = typeof window !== 'undefined' && window.innerWidth >= 768;